// Per-tab visibility flags for the Set Scope / Measurement data filter pages. Defaults keep today's pages:
// both existing tabs shown, new tab hidden.
const readFlag = (value: string | undefined, fallback: boolean): boolean => {
    const normalized = (value ?? '').trim().toLowerCase()
    if (normalized === 'true') return true
    if (normalized === 'false') return false
    return fallback
}

const existingTabs = {
    // Hide an existing tab by setting its flag to "false" (not done yet; both stay visible).
    filterTab: readFlag(process.env.REACT_APP_FILTER_TAB_FILTERS, true),
    sqlTab: readFlag(process.env.REACT_APP_FILTER_TAB_SQL, true),
}

// Design (Set Scope) page. The new "Chat to Filter" tab is a master switch: when false it never renders.
export const filterTabConfig = {
    nl2sqlTab: readFlag(process.env.REACT_APP_FILTER_TAB_NL2SQL, false),
    ...existingTabs,
}

// Measurement data page: its own switch so the two pages can be rolled out separately.
export const measurementFilterTabConfig = {
    nl2sqlTab: readFlag(process.env.REACT_APP_FILTER_TAB_NL2SQL_MEASUREMENT, false),
    ...existingTabs,
}
